// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.research_container_research__q6kXl {
   width: 80%;
  margin-top: 3%;
  margin-left: 5%;
  display: flex;
  flex: 1 1;
  flex-direction: row;
  align-content: flex-start;
  align-items: flex-start;
  align-self: flex-start;
justify-content: space-around;}


.research_sidebar_link__kxbh4
{
  font-family: var(--bookFontFamily);
  color: var(--hsrcMidBlue);
  font-size: 16px;
}


.research_research_navigation_bar__ano-K {
  vertical-align: "top";
  padding-right: 5%;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-content: flex-start;
  align-items: center;
  align-self: flex-start;}

.research_research_content__3BUpg {
  vertical-align: "top";
  width: 70%;
margin-left: 10%;
  display: flex;
  flex: 8 1;
  flex-direction: column;
  align-content: baseline;
  align-items: left;
  align-self: center; }



.research_divider__r1Lfo {
  width: 100%;
  height: 0px;
  margin-top: 30px;
  margin-bottom: 30px;
  border: 1px solid var(--hsrcLightDark); 
}

.research_text16px__lhD4C {
  font-family: var(--FontFamily);
  font-size: 26px;
  color: var(--hsrcDarkBlue);
}

.research_text18pxOrange__qESnq {
  font-family: var(--FontFamily);
  font-size: 18px;
  color: var(--hsrcOrange);
}





`, "",{"version":3,"sources":["webpack://./src/pages/Research/research.module.css"],"names":[],"mappings":"AAAA;GACG,UAAU;EACX,cAAc;EACd,eAAe;EACf,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;AACxB,6BAA6B,CAAC;;;AAG9B;;EAEE,kCAAkC;EAClC,yBAAyB;EACzB,eAAe;AACjB;;;AAGA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB,CAAC;;AAEzB;EACE,qBAAqB;EACrB,UAAU;AACZ,gBAAgB;EACd,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB,EAAE;;;;AAItB;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,wBAAwB;AAC1B","sourcesContent":[".container_research {\r\n   width: 80%;\r\n  margin-top: 3%;\r\n  margin-left: 5%;\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: row;\r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n  align-self: flex-start;\r\njustify-content: space-around;}\r\n\r\n\r\n.sidebar_link\r\n{\r\n  font-family: var(--bookFontFamily);\r\n  color: var(--hsrcMidBlue);\r\n  font-size: 16px;\r\n}\r\n\r\n\r\n.research_navigation_bar {\r\n  vertical-align: \"top\";\r\n  padding-right: 5%;\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: column;\r\n  align-content: flex-start;\r\n  align-items: center;\r\n  align-self: flex-start;}\r\n\r\n.research_content {\r\n  vertical-align: \"top\";\r\n  width: 70%;\r\nmargin-left: 10%;\r\n  display: flex;\r\n  flex: 8;\r\n  flex-direction: column;\r\n  align-content: baseline;\r\n  align-items: left;\r\n  align-self: center; }\r\n\r\n\r\n\r\n.divider {\r\n  width: 100%;\r\n  height: 0px;\r\n  margin-top: 30px;\r\n  margin-bottom: 30px;\r\n  border: 1px solid var(--hsrcLightDark); \r\n}\r\n\r\n.text16px {\r\n  font-family: var(--FontFamily);\r\n  font-size: 26px;\r\n  color: var(--hsrcDarkBlue);\r\n}\r\n\r\n.text18pxOrange {\r\n  font-family: var(--FontFamily);\r\n  font-size: 18px;\r\n  color: var(--hsrcOrange);\r\n}\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_research": `research_container_research__q6kXl`,
	"sidebar_link": `research_sidebar_link__kxbh4`,
	"research_navigation_bar": `research_research_navigation_bar__ano-K`,
	"research_content": `research_research_content__3BUpg`,
	"divider": `research_divider__r1Lfo`,
	"text16px": `research_text16px__lhD4C`,
	"text18pxOrange": `research_text18pxOrange__qESnq`
};
export default ___CSS_LOADER_EXPORT___;
